export default {"src":"/_next/static/media/paw-icon.1153ecf3.svg","height":42,"width":50,"blurWidth":0,"blurHeight":0};